<bdo-large-popup [isVisible]="isVisible()" (closePopupEvent)="cancel()" [isManuallyClosable]="false">

  <div class="re-flex re-flex-auto re-flex-col re-min-h-full re-py-30 re-px-30 md:re-py-[64px] md:re-px-[80px]"
  >
    <div class="popup-content">
      <h4 class="re-pb-30">{{ title() }}</h4>
      <ng-content>
      </ng-content>
      <div class="re-flex re-flex-col re-content-center re-justify-center md:re-flex-row md:re-content-end md:re-justify-end re-pt-30">
        <button class="re-button re-secondary md:re-mr-20" (click)=" cancel()">{{ cancelText() }}</button>
        <button class="re-button re-primary re-mt-15 md:re-mt-0" (click)="confirm()">{{ confirmText() }}</button>
      </div>
    </div>
  </div>
</bdo-large-popup>
